import styles from "./VisuallyHidden.module.scss";

const VisuallyHidden = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.root}>{children}</div>;
};

export default VisuallyHidden;
